<template lang="pug">
section.section.section-background-grey(v-if="!accessToken")
	.section-content
		.has-text-centered
			.title.is-spaced {{ $t('about.title6') }}
			p.subtitle
				| {{ $t('about.submit_phone_number') }}
		.form-container.form-inline
			.columns.is-centered.is-vcentered
				.column: .field
					label.label {{ $t('label.name_surname') }}
					.control
						input.input(type="text" v-model="name" :disabled="formSubmit || errorSubmit" maxlength="50")
				.column: .field
					label.label {{ $t('label.company') }}
					.control
						input.input(type="text" v-model="company" :disabled="formSubmit || errorSubmit" maxlength="50")
				.column: .field
					label.label {{ $t('label.mobile') }}
					.control
						input.input(type="text" v-model="mobile" :disabled="formSubmit || errorSubmit" maxlength="15")

				.column.no-grow
					.field
						label.label.is-hidden-mobile &nbsp;
						.control.has-text-centered
							button.button.is-primary(type="button" v-bind:class="buttonClass" @click="submitRequest" :disabled="formSubmit || errorSubmit")
								| {{ $t('button.submit') }}

			article.message.is-success(v-if="formSubmit" transition="fade")
				.message-body
					| {{ $t('alert.request_sent') }}
			article.message.is-danger(v-if="errorSubmit" transition="fade")
				.message-body
					| {{ $t('alert.error') }}
			article.message.is-danger(v-if="invalidSubmit" transition="fade")
				.message-body
					| {{ $t('alert.request_invalid') }}
			article.message.is-danger(v-if="errorName" transition="fade")
				.message-body
					| {{ $t('alert.missing_name') }}
			article.message.is-danger(v-if="errorCompany" transition="fade")
				.message-body
					| {{ $t('alert.missing_company') }}
			article.message.is-danger(v-if="errorMobile" transition="fade")
				.message-body
					| {{ $t('alert.missing_mobile') }}

			p.has-text-justified.privacy-text {{ $t('privacy.mobile_form') }}
</template>

<script>
import TitleComponent from '../TitleComponent.vue'
import { ChevronRightIcon } from 'vue-feather-icons'

export default {
	name      : 'SectionForm',
	components: {
		TitleComp: TitleComponent,
		ChevronRightIcon
	},
	data() {
		return {
			name         : '',
			mobile       : '',
			company      : '',
			errorName    : false,
			errorCompany : false,
			errorMobile  : false,
			formSubmit   : false,
			errorSubmit  : false,
			invalidSubmit: false
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		loading() {
			return this.$store.state.ticket.loading
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		}
	},
	methods: {
		submitRequest() {
			if (!this.name) {
				this.errorName = true
				return
			}

			if (!this.company) {
				this.errorCompany = true
				return
			}

			if (!this.mobile || this.mobile.length < 7) {
				this.errorMobile = true
				return
			}

			const mobile = this.mobile.replace(/\s/g, '')
			if ((/^(\+\d{1,7}[./:-]\d{6,})$/).test(mobile) || (/^\d+$/).test(mobile)) {

				if (this.loading) return
				this.$store.dispatch('ticket/submitRequest', {
					name   : this.name,
					mobile : this.mobile,
					company: this.company
				})
					.then(response => {
						this.formSubmit = true
						this.errorSubmit = false
						this.invalidSubmit = false

						this.errorName = false
						this.errorCompany = false
						this.errorMobile = false
					})
					.catch(err => {
						this.formSubmit = false
						if (err.response && err.response.status) {
							switch (err.response.status) {
								case 400:
									this.errorSubmit = false
									this.invalidSubmit = true
									break
								case 500:
									this.invalidSubmit = false
									this.errorSubmit = true
									break
								default:
									console.warn(err.response.status)
							}
						}
					})
			} else {
				this.errorMobile = true
				this.errorSubmit = false
				this.invalidSubmit = false
			}
		}
	},
	watch: {
		name() {
			this.errorName = false
			this.invalidSubmit = false
		},
		company() {
			this.errorCompany = false
			this.invalidSubmit = false
		},
		mobile() {
			this.errorMobile = false
			this.invalidSubmit = false
		}
	}
}
</script>
